module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/icon_title_hibiscus_orange-ed03d06adf049576f53a82fa1d0cbb1f.svg";